import { InsertFlowstep } from './insertFlowstep';
import { mergeObjects } from 'shared/excel/runtime/merge';
import { MappingSymbolsCount, PUSH_FLOWSTEP_RESULT_HEADER } from 'shared/excel/runtime/flowstepExecution';


export class MergeObjects extends InsertFlowstep {
  constructor(flowstep, meta, parent) {
    super(flowstep, meta, parent);

    this.resultIndexes.id = this.resultTableHeaders.findIndex(x => x.key === PUSH_FLOWSTEP_RESULT_HEADER.MergeId.key);
  }

  // override InsertFlowstep
  async _applyFlowstepData_(headers) {
    const { options } = this.flowstep;
    const { batchSize, parallelCount, runSynchronously, merge } = options;
    
    const { columnIndexes, processRow, mapping } = await mergeObjects(headers, merge, this.applyFnContext);
    const { objectName, constants } = mapping;

    this.requestContext = { columnIndexes, processRow };
    this.options = { batchSize, runSynchronously, parallelCount, objectName, constants };

    return columnIndexes.map(x => MappingSymbolsCount.id);
  }
};
